const BRAND_CURATION_TASK_TAGS = {
  IS_PROBLEMATIC: {
    value: 'IS_PROBLEMATIC',
    label: 'is problematic',
    excludedBy: ['IS_NOT_PROBLEMATIC'],
  },
  IS_TEST: {
    value: 'IS_TEST',
    label: 'is test',
    excludedBy: ['IS_NOT_TEST'],
  },
  IS_TRAINING: {
    value: 'IS_TRAINING',
    label: 'is training',
    excludedBy: ['IS_NOT_TRAINING'],
  },
  EXCLUDE_FROM_REPORTS: {
    value: 'EXCLUDE_FROM_REPORTS',
    label: 'exclude from reports',
  },
  MANDATORY_TRAINING: {
    value: 'MANDATORY_TRAINING',
    label: 'mandatory training',
  },
  HOMEWORK_TRAINING: {
    value: 'HOMEWORK_TRAINING',
    label: 'homework training',
  },
  HAS_UNCAUGHT_AI_ERROR: {
    value: 'HAS_UNCAUGHT_AI_ERROR',
    label: 'Has uncaught AI error',
    disabled: true,
  },
  HAS_UNCAUGHT_MENU_CURATOR_ERROR: {
    value: 'HAS_UNCAUGHT_MENU_CURATOR_ERROR',
    label: 'Has uncaught Menu Curator error',
    disabled: true,
  },
  HAS_TIMEOUT_ERROR: {
    value: 'HAS_TIMEOUT_ERROR',
    label: 'Has timeout error',
    disabled: true,
  },
}

export default BRAND_CURATION_TASK_TAGS
